import { render, staticRenderFns } from "./vita.vue?vue&type=template&id=65b5d912&scoped=true&"
import script from "./vita.vue?vue&type=script&lang=js&"
export * from "./vita.vue?vue&type=script&lang=js&"
import style0 from "./vita.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./vita.vue?vue&type=style&index=1&id=65b5d912&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b5d912",
  null
  
)

export default component.exports